import { render } from "./DefaultSelect.vue?vue&type=template&id=ec8d367c&scoped=true"
import script from "./DefaultSelect.vue?vue&type=script&lang=js"
export * from "./DefaultSelect.vue?vue&type=script&lang=js"

import "./DefaultSelect.vue?vue&type=style&index=0&id=ec8d367c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec8d367c"]])

export default __exports__